module.exports = __webpack_public_path__ + "static/media/mailchimp-editor.19c3d397.png";